
export function task(state = null, action) {
    switch (action.type) {
        case 'changeSelectedTask':
            return action.task;

        default:
            return state
    }
}
